import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { extractData, extractItems } from '../api/api-response.util';
import { ApiService } from '../api/api.service';
import { AppNotification, NotificationListParams, NotificationListResponse } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private readonly api: ApiService) {}

  list(params?: NotificationListParams): Observable<NotificationListResponse> {
    const queryParams = Object.fromEntries(
      Object.entries({
        page: params?.page ?? 1,
        limit: params?.limit ?? 20
      }).filter(([, value]) => value !== undefined)
    ) as Record<string, string | number | boolean>;

    return this.api.get<unknown>('/notifications', queryParams).pipe(
      map((response) => ({
        items: extractItems<AppNotification>(response),
        count: Number(extractData(response)['count'] ?? 0)
      }))
    );
  }

  unreadCount(): Observable<number> {
    return this.api.get<unknown>('/notifications/unread-count').pipe(map((response) => Number(extractData(response)['count'] ?? 0)));
  }

  markRead(notificationPublicId: string): Observable<void> {
    return this.api.patch<void>(`/notifications/${notificationPublicId}/read`, {});
  }

  markAllRead(): Observable<void> {
    return this.api.patch<void>('/notifications/read-all', {});
  }
}
